/**
 * @generated SignedSource<<1dc2ea96ccb384461669c741cd9d4a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateTodoTextResponseInput = {
  text?: string | null;
};
export type TodoEditNewMainFooterResponseTextrMutation$variables = {
  input: UpdateTodoTextResponseInput;
  todoId: string;
};
export type TodoEditNewMainFooterResponseTextrMutation$data = {
  readonly todo: {
    readonly updateTextResponse: {
      readonly canChangeStatus: boolean;
      readonly isResponseCompleted: boolean;
      readonly parent: {
        readonly canChangeStatus: boolean;
      } | null;
      readonly response: {
        readonly text?: string | null;
      } | null;
    };
  } | null;
};
export type TodoEditNewMainFooterResponseTextrMutation = {
  response: TodoEditNewMainFooterResponseTextrMutation$data;
  variables: TodoEditNewMainFooterResponseTextrMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponseCompleted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeStatus",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "TodoResponseText",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditNewMainFooterResponseTextrMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateTextResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditNewMainFooterResponseTextrMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "updateTextResponse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e9fa78fe1b5102950a75bb0ebc2016ad",
    "id": null,
    "metadata": {},
    "name": "TodoEditNewMainFooterResponseTextrMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditNewMainFooterResponseTextrMutation(\n  $todoId: ID!\n  $input: UpdateTodoTextResponseInput!\n) {\n  todo(todoId: $todoId) {\n    updateTextResponse(input: $input) {\n      isResponseCompleted\n      canChangeStatus\n      parent {\n        canChangeStatus\n        id\n      }\n      response {\n        __typename\n        ... on TodoResponseText {\n          text\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b612f2bf105128a13991898d32d2417";

export default node;
